export default __webpack_public_path__ + "be1ced7a083dfb9893b352e84934d57f.svg";